export default __webpack_public_path__ + "14b6dfe35b2503469f49c5e1637cdfa9.png";